import React from "react";
import Typography from "@mui/material/Typography";
import {CPSConstants} from "commonUtils/enumerations";

interface CustomTypographyProps {
  variant?:
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "subtitle1"
    | "subtitle2"
    | "body1"
    | "body2"
    | "button"
    | "caption"
    | "overline";
  outlet?: React.ReactNode;
}

const FormParagraph: React.FC<CustomTypographyProps> = ({
  variant,
  outlet,
  ...props
}) => {
  return (
    <Typography
      component="span"
      variant={variant}
      {...props}
      sx={{
        fontSize: CPSConstants.FONTREMTEXT,
        fontWeight: CPSConstants.FONTWEIGHT,
        m: "0 0 0 0",
      }}>
      {outlet}
    </Typography>
  );
};

export default FormParagraph;
